import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useHelperTextStylesForAmbientTemperature } from '../styles';
import WdTextField from '../WdTextField';
import TextField from '@material-ui/core/TextField';
import Chips from '../Chips/Chips';
import { FONT_FAMILIES } from '../../../styles/constants';
import { COLORS } from './../../../styles/constants';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SupplyTypeTemperature = ({ screenWidth, ...props }) => {
	const { t } = useTranslation();
	const helperTextStyles = useHelperTextStylesForAmbientTemperature();
	const { values, errors, handleChange, handleBlur, setValues } = props.formikProps;
	const appliedStateOfQuickFilter = useSelector(state => state.filters.appliedState);
	const supplyType = appliedStateOfQuickFilter.pwcv.value.toString().substring(0, 2);

	const changeLineFrequency = lineFrequency => {
		setValues({ ...values, lineFrequency });
	};

	return (
		<Grid>
			<Grid
				style={{
					marginBottom: '20px'
				}}></Grid>

			<Grid>
				<label htmlFor="Input__ambientTemperature_text_field">
					<span>
						<span>{t('main:components.wdValidators.input.supplyTypeTemperature.temperature')}, </span>
						<span
							style={{
								color: COLORS.TEXT_SECONDARY
							}}>
							T<sub>a</sub>:{'\u00a0' + '\u00a0' + '\u00a0'}
						</span>

						<span>
							<span
								style={{
									color: COLORS.SECONDARY,
									fontWeight: 'bold'
								}}>
								<WdTextField
									id="AmbientTemperature_text_field"
									name="ambientTemperature"
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												&deg;C{'\u00a0'}
												{'\u00a0'}
											</InputAdornment>
										)
									}}
									maxLength={10}
									errors={errors}
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.ambientTemperature}
									FormHelperTextProps={{
										classes: {
											root: helperTextStyles.root
										}
									}}
								/>
							</span>
						</span>
					</span>
				</label>
				<Grid>
					<span>
						<TextField
							id="Error_messages_for_ambient_temperature"
							name="ambientTemperatureErrors"
							InputProps={{
								readOnly: true,
								disableUnderline: true
							}}
							maxLength={0}
							onChange={handleChange}
							onBlur={handleBlur}
							value={''}
							helperText={errors.ambientTemperature ? errors.ambientTemperature : '\u00a0'}
							error={errors.ambientTemperature}
							FormHelperTextProps={{
								classes: {
									root: helperTextStyles.root
								}
							}}
						/>
					</span>
				</Grid>
			</Grid>

			{supplyType === 'AC' ? (
				<Grid
					container
					style={{
						marginTop: '1px',
						paddingTop: '0px',
						paddingBottom: '5px',
						alignItems: 'center'
					}}>
					<span
						style={{
							fontFamily: FONT_FAMILIES,
							whiteSpace: 'pre'
						}}>
						{t('main:components.wdValidators.input.supplyTypeTemperature.supplyFrequency')}:{'\u00a0'}
					</span>
					<Chips
						value={values.lineFrequency.toString()}
						updateValue={changeLineFrequency}
						chips={[
							{ label: '50 Hz', value: '50' },
							{ label: '60 Hz', value: '60' }
						]}
					/>
				</Grid>
			) : (
				<Grid
					container
					wrap="nowrap"
					style={{
						height: '30px'
					}}></Grid>
			)}
		</Grid>
	);
};

SupplyTypeTemperature.propTypes = {
	screenWidth: PropTypes.number.isRequired
};

export default SupplyTypeTemperature;
